import React, { useContext, useRef, useEffect, useState } from 'react';
import { AudioContext } from '../context/AudioContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause, faHeart, faThumbsUp, faThumbsDown, faVolumeHigh } from '@fortawesome/free-solid-svg-icons';
import { likeChannel, dislikeChannel, favoriteChannel } from '../services/PlayerServices';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const AudioPlayer = () => {
    const { currentChannel, isPlaying, setIsPlaying } = useContext(AudioContext);
    const audioRef = useRef(null);
    const [volume, setVolume] = useState(1); // Default volume is 1 (max)
    const [, setLiked] = useState(false);
    const [, setDisliked] = useState(false);
    const [, setFavorite] = useState(false);

    useEffect(() => {
        // Retrieve saved volume from localStorage
        const savedVolume = localStorage.getItem('audioVolume');
        if (savedVolume !== null) {
            setVolume(parseFloat(savedVolume)); // Convert to number
        }
    }, []);

    useEffect(() => {
        if (audioRef.current) {
            audioRef.current.volume = volume; // Apply saved volume
        }
    }, [volume]);

    useEffect(() => {
        if (audioRef.current && currentChannel) {
            if (audioRef.current.src !== currentChannel.url_resolved) {
                audioRef.current.src = currentChannel.url_resolved;
                if (isPlaying) {
                    audioRef.current.play().catch((error) => {
                        console.error('Error playing audio:', error);
                    });
                }
            }
        }
    }, [currentChannel, isPlaying]);

    const handleLike = async () => {
        if (!currentChannel) return;
        if (await likeChannel(currentChannel.id)) {
            setLiked(true);
            setDisliked(false);
            toast.success("Liked the channel!", { position: "top-right" });
        } else {
            toast.error("Failed to like the channel.", { position: "top-right" });
        }
    };
    
    const handleFavorite = async () => {
        if (!currentChannel) return;
        if (await favoriteChannel(currentChannel.id)) {
            setFavorite(true);
            toast.success("Added to favorites!", { position: "top-right" });
        } else {
            toast.error("Failed to add to favorites.", { position: "top-right" });
        }
    };
    
    const handleDislike = async () => {
        if (!currentChannel) return;
        if (await dislikeChannel(currentChannel.id)) {
            setDisliked(true);
            setLiked(false);
            toast.info("Disliked the channel.", { position: "top-right" });
        } else {
            toast.error("Failed to dislike the channel.", { position: "top-right" });
        }
    };

    useEffect(() => {
        if (audioRef.current) {
            isPlaying ? audioRef.current.play().catch(console.error) : audioRef.current.pause();
        }
    }, [isPlaying]);

    const togglePlayPause = () => {
        if (!audioRef.current) return;
        setIsPlaying((prevState) => !prevState);
    };

    const handleVolumeChange = (e) => {
        const newVolume = parseFloat(e.target.value);
        setVolume(newVolume);
        localStorage.setItem('audioVolume', newVolume);
        if (audioRef.current) {
            audioRef.current.volume = newVolume;
        }
    };

    return (
        <div class="audio-player">
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} className='audio-player-info'>
                <img
                    src={currentChannel?.favicon || 'https://static.vecteezy.com/system/resources/thumbnails/014/321/556/small/radio-logo-template-icon-illustration-vector.jpg'}
                    alt="Album Art"
                    style={{
                        width: '50px',
                        height: '50px',
                        borderRadius: '5px',
                        marginRight: '10px',
                    }}
                />
                <span>{currentChannel?.name || 'Unknown Channel'}</span>
                <button onClick={handleFavorite} style={{ color: 'white', width: '30px' }}>
                    <FontAwesomeIcon icon={faHeart} />
                </button>
            </div>

            <hr className='border-line'/>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} className='player-controls'>
                <button onClick={handleDislike} style={buttonStyle}>
                    <FontAwesomeIcon icon={faThumbsDown} />
                </button>
                <button onClick={togglePlayPause} style={buttonStyle}>
                    <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
                </button>
                <button onClick={handleLike} style={buttonStyle}>
                    <FontAwesomeIcon icon={faThumbsUp} />
                </button>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} className="audio-controls">
                <audio ref={audioRef} preload="auto" />
                <button style={buttonStyle}>
                    <FontAwesomeIcon icon={faVolumeHigh} />
                </button>
                <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={volume} // Set current volume
                    onChange={handleVolumeChange}
                    style={{ width: '100px', marginLeft: '1px', borderRadius: '10px' }}
                />
            </div>
        </div>
    );
};

const buttonStyle = {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    border: '1px solid #ccc',
    background: '#fff',
    cursor: 'pointer',
};

export default AudioPlayer;
